// removed by extract-text-webpack-plugin
module.exports = {"Img":"src-components-ProductType-__ProductTypesTable-module___Img"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ProductType/ProductTypesTable.module.css
// module id = 1239
// module chunks = 1